import CustomAppBar from 'Components/Layout/CustomAppBar'
import StyledToolbar from 'Components/Layout/StyledToolbar'
import MenuBarAppName from 'Components/MenuBarAppName'
import type { FC } from 'react'

const UnauthenticatedMenuBar: FC = () => {
  return (
    <CustomAppBar>
      <StyledToolbar>
        <MenuBarAppName />
      </StyledToolbar>
    </CustomAppBar>
  )
}

export default UnauthenticatedMenuBar
